import { type GetProjectQueryParams } from '@gonfalon/openapi/operations/getProject';

import { createQueryHook } from '../internal/createQueryHook';
import { projectsDetail } from '../queries/projectsDetail';

/**
 * @deprecated Use `projectsDetail()` with `useQuery` directly.
 */
export const useProject = createQueryHook(
  ({ projectKey, params }: { projectKey: string; params?: GetProjectQueryParams }) =>
    projectsDetail({ projectKey, query: params }),
);
